import React, { useEffect, useRef } from 'react';
import { Outlet, useParams, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import FeedbackWidget from './FeedbackWidget';
import MaintenanceBanner from './MaintenanceBanner';
import DonationPopup from './DonationPopup';
import { useLanguage } from '@/contexts/LanguageContext';

// Set to true to show maintenance banner, false to hide
const MAINTENANCE_MODE = false;

export const Layout = ({ isRoot = false }) => {
  const { lang } = useParams();
  const location = useLocation();
  const { changeLanguage, currentLang } = useLanguage();
  const hasInitialized = useRef(false);

  // For root path, default to 'en' if no lang param
  const effectiveLang = isRoot ? 'en' : lang;

  // Sync language context with URL param - only when URL changes
  useEffect(() => {
    if (effectiveLang && effectiveLang !== currentLang && !hasInitialized.current) {
      changeLanguage(effectiveLang);
    }
    hasInitialized.current = true;
  }, [effectiveLang]);

  // Handle subsequent URL changes
  useEffect(() => {
    if (hasInitialized.current && effectiveLang && effectiveLang !== currentLang) {
      changeLanguage(effectiveLang);
    }
  }, [effectiveLang, currentLang, changeLanguage]);

  return (
    <div className="min-h-screen flex flex-col bg-[#05070A]">
      <MaintenanceBanner enabled={MAINTENANCE_MODE} />
      <Navbar isRoot={isRoot} maintenanceMode={MAINTENANCE_MODE} />
      <main key={location.pathname} className={`flex-1 ${MAINTENANCE_MODE ? 'pt-24' : 'pt-16'}`}>
        <Outlet />
      </main>
      <Footer />
      <FeedbackWidget />
      <DonationPopup />
    </div>
  );
};

export default Layout;
